export interface Cuisine {
  id: string;
  label: string;
  region: string;
}

export const cuisines: Cuisine[] = [
  { id: 'thai', label: 'Thai', region: 'Thailand' },
  { id: 'isan', label: 'Isan & Northeastern', region: 'Thailand' },
  { id: 'southern-thai', label: 'Southern Thai', region: 'Thailand' },
  { id: 'northern-thai', label: 'Northern Thai', region: 'Thailand' },
  { id: 'vietnamese', label: 'Vietnamese', region: 'Southeast Asia' },
  { id: 'cantonese', label: 'Cantonese & Teochew', region: 'East Asia' },
  { id: 'japanese', label: 'Japanese', region: 'East Asia' },
  { id: 'korean', label: 'Korean', region: 'East Asia' },
  { id: 'indian', label: 'Indian', region: 'South Asia' },
  { id: 'peranakan', label: 'Malay & Peranakan', region: 'Southeast Asia' },
  { id: 'italian', label: 'Italian', region: 'Europe' },
  { id: 'french', label: 'French', region: 'Europe' },
  { id: 'levantine', label: 'Levantine', region: 'Middle East' },
  { id: 'bbq', label: 'Live fire & charcoal', region: 'Global' },
  { id: 'plant', label: 'Plant-forward', region: 'Global' },
  { id: 'pastry', label: 'Pastry & desserts', region: 'Global' },
];

export function cuisineLabel(id: string): string {
  return cuisines.find((c) => c.id === id)?.label ?? id;
}

export interface EquipmentDef {
  id: string;
  label: string;
}

export const equipmentCatalog: EquipmentDef[] = [
  { id: 'oven', label: 'Working oven' },
  { id: 'induction_pan', label: 'Induction-safe pans' },
  { id: 'wok', label: 'Carbon steel wok' },
  { id: 'wok_burner', label: 'High-output gas burner' },
  { id: 'mortar', label: 'Granite mortar & pestle' },
  { id: 'steamer', label: 'Bamboo or metal steamer' },
  { id: 'sticky_steamer', label: 'Sticky rice basket & pot' },
  { id: 'heavy_skillet', label: 'Heavy cast-iron skillet' },
  { id: 'charcoal_grill', label: 'Charcoal grill or tao' },
  { id: 'blender', label: 'High-speed blender' },
  { id: 'food_processor', label: 'Food processor' },
  { id: 'blowtorch', label: 'Kitchen blowtorch' },
  { id: 'thermometer', label: 'Probe thermometer' },
  { id: 'large_stockpot', label: 'Large stockpot' },
  { id: 'sharp_knives', label: 'Sharp knives' },
  { id: 'rice_cooker', label: 'Rice cooker' },
];

export function equipmentLabel(id: string): string {
  return equipmentCatalog.find((e) => e.id === id)?.label ?? id;
}

export const allergens: string[] = [
  'Peanuts',
  'Tree nuts',
  'Shellfish',
  'Fish',
  'Eggs',
  'Dairy',
  'Soy',
  'Wheat / gluten',
  'Sesame',
  'Celery',
  'Mustard',
  'Sulphites',
];

export const diets: string[] = [
  'Vegetarian',
  'Vegan',
  'Jay (Buddhist vegan)',
  'Pescatarian',
  'Halal',
  'Gluten-free',
  'Dairy-free',
  'No pork',
  'No beef',
  'No alcohol',
  'No shrimp paste / fish sauce',
];

export const intolerances: string[] = ['Lactose', 'Gluten', 'Fructose', 'Histamine', 'Caffeine', 'Alliums'];

export const occasions: string[] = [
  'Dinner party',
  'Date night',
  'Birthday',
  'Anniversary',
  'Family weekend',
  'Weekly meal prep',
  'Condo rooftop party',
  'Songkran or festival table',
  'Corporate dinner',
  'Merit-making lunch',
];

export const dietaryCapabilities: string[] = [
  'Chilli level to order',
  'No fish sauce or shrimp paste',
  'Jay (Buddhist vegan) menus',
  'Halal sourcing',
  'Gluten-free menus',
  'Nut-free kitchen practice',
  'Allergen-separated prep',
  'Low-sodium',
];
